import { render } from "./DualCard.vue?vue&type=template&id=1f079328&scoped=true"
import script from "./DualCard.vue?vue&type=script&lang=js"
export * from "./DualCard.vue?vue&type=script&lang=js"

import "./DualCard.vue?vue&type=style&index=0&id=1f079328&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f079328"]])

export default __exports__